/**
 * @generated SignedSource<<4deae0518fba6e99c77f641a191fad0b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LocaleSwitch_platform",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "publishedLocales",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "useLocaleNamesInsteadOfFlags",
      "storageKey": null
    }
  ],
  "type": "Platform",
  "abstractKey": null
};

node.hash = "8c5bc423f72b804b923fc8fee2ec34f8";

module.exports = node;
